import { ROLES } from "../constants";

// Matches a role value against the ROLES enum case-insensitively, returning
// the canonical (correctly-cased) value, or the original value if no match.
export const resolveRoleCaseInsensitive = (role) => {
  if (!role) return role;
  const normalized = String(role).trim().toLowerCase();
  const match = Object.values(ROLES).find(
    (canonical) => canonical.toLowerCase() === normalized,
  );
  return match || role;
};
